const userBio = { name: "John Smith", jobTitle: "Front End Developer" };

const phoneContact = {
  id: "01bacdff-b250-4db1-8cab-140bd8846e40",
  iconId: 8,
  iconName: "phone-icon",
  data: "+081 234 5678",
  link: "",
};

const emailContact = {
  id: "f919a4ca-8013-46fa-940f-20093de56d9e",
  iconId: 2,
  iconName: "envelope-icon",
  data: "john_smith@mail.com",
  link: "",
};

const houseContact = {
  id: "b6302a3a-3364-44b8-ac60-fc15cbe24d9a",
  iconId: 5,
  iconName: "house-icon",
  data: "San Francisco, CA",
  link: "",
};

const linkedInContact = {
  id: "4d6d8de3-06d8-4e98-aab1-bfd9718a1c75",
  iconId: 7,
  iconName: "linkedIn-icon",
  data: "/in/john_smith",
  link: "https://www.linkedin.com/in/John_john123",
};

const userContact = [phoneContact, emailContact, houseContact, linkedInContact];

const userProfile = {
  profileSummary:
    "Write a few sentences about yourself. Start with years of experience or education. Put skills that will be able to contribute to the specific job. Bonus points if you have relevant specialties and achievements. Convince them you're the best choice. Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
};

const education1 = {
  id: "7d477101-5f98-417e-b0e3-1cfdfd7ef75d",
  name: "Bachelor of Information Technology",
  institution: "University Name",
  yearStart: 2012,
  yearEnd: 2016,
};

const educationInfo = {
  id: "12ea1064-7bfe-444b-a671-4d84900d7091",
  type: "info",
  name: "education",
  items: [education1],
};

const language1 = {
  id: "686e8d40-4f8e-4e48-827b-98c9c3f1b5d2",
  name: "English",
  proficiency: "Native Speaker",
};
const language2 = {
  id: "ad662644-7978-4716-8e70-561e80f28dbf",
  name: "Spanish",
  proficiency: "Basic",
};

const languageList = {
  id: "d9b922a1-651f-4822-b00b-3f9e32b3fd51",
  type: "list",
  name: "language",
  proficiencyType: "level", //none/score/level
  items: [language1, language2],
};

const softSKill1 = {
  id: "6b6edcd7-5398-4b06-a48b-72b836405107",
  name: "Project management",
};

const softSKill2 = {
  id: "7439ffd4-ba04-446d-9656-62824bcbe9f9",
  name: "Problem-solving",
};

const softSkillList = {
  id: "41763298-31c1-4809-827c-5a8ff123a1e1",
  type: "list",
  name: "softSkill",
  proficiencyType: "none", //none/score/level
  items: [softSKill1, softSKill2],
};

const software1 = {
  id: "b8ab04a2-c19a-449d-a14f-4dd0c10f5687",
  name: "Microsoft Word",
  proficiency: "4",
};
const software2 = {
  id: "1772b696-079c-4543-b092-906fb9537f20",
  name: "Microsoft Excel",
  proficiency: "2",
};

const softwareList = {
  id: "8016d258-a578-42d5-80e1-d7c62b20d9d1",
  type: "list",
  name: "software",
  proficiencyType: "score", //none/score/level
  items: [software1, software2],
};

const experience1 = {
  id: "fc9aea70-de76-40ef-928d-e5e7e13e50e2",
  jobTitle: "Job Title Here",
  companyName: "Company Name",
  location: "Location",
  yearStart: "20XX",
  yearEnd: "20XX",
  jobSummary:
    "Put a brief summary of your duties in this paragraph and highlight details in the bullet list. Be accurate and concise. Remember: You are trying to show that your experience from previous jobs makes you ideal for this one.",
  jobDetails: [
    {
      id: "115e90b6-ca2a-46dc-8081-0fee2811d60f",
      item: "Formulate program specifications and basic prototypes",
    },
    {
      id: "6faf5255-f19a-4740-b91c-4690608a9bc9",
      item: "Integrate individual software solutions to higher level systems",
    },
    {
      id: "d988dc8b-f7e3-4cfb-85a8-e5be34d2d5fd",
      item: "Use web-based tools to create advanced SaaS when applicable",
    },
  ],
};

const experience2 = {
  id: "635a0e8c-7641-48fd-b60f-9ce8baace4fb",
  jobTitle: "Job Title Here",
  companyName: "Company Name",
  location: "Location",
  yearStart: "20XX",
  yearEnd: "20XX",
  jobSummary:
    "Put a brief summary of your duties in this paragraph and highlight details in the bullet list. Be accurate and concise. Remember: You are trying to show that your experience from previous jobs makes you ideal for this one.",
  jobDetails: [
    {
      id: "b5c1a722-88af-4c49-891f-9081cc6655bc",
      item: "Formulate program specifications and basic prototypes",
    },
    {
      id: "8c3c27d6-e72d-4acc-a9a5-acfd18b4d916",
      item: "Integrate individual software solutions to higher level systems",
    },
    {
      id: "2373a89f-b468-40c2-8e28-89c3849c7046",
      item: "Use web-based tools to create advanced SaaS when applicable",
    },
  ],
};

const experience = {
  id: "bf254536-052f-4825-b366-5cfc18cde5ca",
  type: "experience",
  items: [experience1, experience2],
};

const reference1 = {
  id: "0fcf1730-7ece-4819-af9d-86699dddc602",
  name: "Put Name Here",
  jobTitle: "Job Title",
  companyName: "Company Name",
  phone: "081-234-5678",
  email: "reference@mail.com",
};

const reference2 = {
  id: "2ac588d8-72b5-4c4d-8c33-ddad0faca739",
  name: "Put Name Here",
  jobTitle: "Job Title",
  companyName: "Company Name",
  phone: "081-234-5678",
  email: "reference@mail.com",
};

const references = {
  id: "501c8cb0-f3e4-4da5-9654-f6e609749626",
  type: "reference",
  items: [reference1, reference2],
};

const defaultResume = {
  bio: userBio,
  contact: userContact,
  profile: userProfile,
  leftContents: [educationInfo, languageList, softSkillList, softwareList],
  rightContents: [experience, references],
};

const contactTemplate = {
  iconId: 8,
  iconName: "phone-icon",
  data: "Contact data",
  link: "",
};

const infoItemTemplate = {
  name: "Put Degree/ Achievement/ Certification Here",
  institution: "Stanford University",
  yearStart: "20XX",
  yearEnd: "20XX",
};

const infoTemplate = {
  type: "info",
  name: "Info Name",
  items: [infoItemTemplate],
};

const listProficiencyItemTemplate = {
  name: "List item",
  proficiency: "Beginner",
};

const listProficiencyTemplate = {
  type: "list",
  name: "List Name",
  proficiencyType: "level", //none/score/level
  items: [listProficiencyItemTemplate],
};

const listBasicTemplate = {
  type: "list",
  name: "List Name",
  proficiencyType: "none", //none/score/level
  items: [{ name: "List item" }],
};

const listScoreItemTemplate = { name: "List item", proficiency: "4" };

const listScoreTemplate = {
  type: "list",
  name: "List name",
  proficiencyType: "score", //none/score/level
  items: [listScoreItemTemplate],
};

const experienceItemTemplate = {
  jobTitle: "Job Title Here",
  companyName: "Company Name",
  location: "Location",
  yearStart: "20XX",
  yearEnd: "20XX",
  jobSummary:
    "Put a brief summary of your duties in this paragraph and highlight details in the bullet list. Be accurate and concise. Remember: You are trying to show that your experience from previous jobs makes you ideal for this one.",
  jobDetails: [
    "Put some details about your job here.",
    "Put some details about your job here.",
  ],
};

const experienceTemplate = {
  type: "experience",
  items: [experienceItemTemplate],
};

const experienceListTemplate = {
  item: "Put some details about your job here.",
};

const referenceItemTemplate = {
  name: "Put Name Here",
  jobTitle: "Job Title",
  companyName: "Company Name",
  phone: "081-234-5678",
  email: "john@mail.com",
};

const referenceTemplate = {
  type: "reference",
  items: [referenceItemTemplate],
};

const objectTemplate = {
  contactTemplate,
  infoTemplate,
  listProficiencyTemplate,
  listBasicTemplate,
  listScoreTemplate,
  experienceTemplate,
  experienceListTemplate,
  referenceTemplate,
};
export { defaultResume, objectTemplate };
